const HQ_LEGAL = {
  privacy: 'https://digitalhustlerscaribbean.com/privacy',
  terms: 'https://digitalhustlerscaribbean.com/terms',
  cookies: 'https://digitalhustlerscaribbean.com/cookies',
};

/** @deprecated Use ../lib/mansionLegalUrls HQ_LEGAL */
export { HQ_LEGAL };

export function toImportSlug(value) {
  return String(value || '')
    .trim()
    .toLowerCase()
    .replace(/&/g, 'and')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

export function applyImportSeoMeta({ title, description, price, currency, canonicalUrl, image }) {
  if (typeof document === 'undefined') return;

  document.title = title;

  const setMeta = (selector, attr, key, value) => {
    if (!value) return;
    let el = document.querySelector(selector);
    if (!el) {
      el = document.createElement('meta');
      el.setAttribute(attr, key);
      document.head.appendChild(el);
    }
    el.setAttribute('content', value);
  };

  setMeta('meta[name="description"]', 'name', 'description', description);
  setMeta('meta[property="og:title"]', 'property', 'og:title', title);
  setMeta('meta[property="og:description"]', 'property', 'og:description', description);
  setMeta('meta[property="og:url"]', 'property', 'og:url', canonicalUrl);
  setMeta('meta[property="og:type"]', 'property', 'og:type', 'product');
  setMeta('meta[property="og:price:amount"]', 'property', 'og:price:amount', String(price));
  setMeta('meta[property="og:price:currency"]', 'property', 'og:price:currency', currency || 'USD');
  if (image) setMeta('meta[property="og:image"]', 'property', 'og:image', image);

  let canonical = document.querySelector('link[rel="canonical"]');
  if (!canonical) {
    canonical = document.createElement('link');
    canonical.rel = 'canonical';
    document.head.appendChild(canonical);
  }
  canonical.href = canonicalUrl;

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'Product',
    name: title,
    description,
    url: canonicalUrl,
    image: image ? [image] : undefined,
    offers: {
      '@type': 'Offer',
      price: String(price),
      priceCurrency: currency || 'USD',
      availability: 'https://schema.org/InStock',
      url: canonicalUrl,
    },
  };

  let script = document.getElementById('cheep-import-jsonld');
  if (!script) {
    script = document.createElement('script');
    script.id = 'cheep-import-jsonld';
    script.type = 'application/ld+json';
    document.head.appendChild(script);
  }
  script.textContent = JSON.stringify(schema);
}
